import {Meta, Title} from '@angular/platform-browser';

export const setSEOInfo = (title: Title, meta: Meta, pageName: string, description: string, imageUrl: string = null,
                           type: string = null) => {
  title.setTitle(pageName);

  meta.updateTag({property: 'og:url', content: window.location.href}, 'property=\'og:url\'');
  meta.updateTag({property: 'og:title', content: pageName}, 'property=\'og:title\'');
  meta.updateTag({property: 'og:description', content: description}, 'property=\'og:description\'');
  meta.updateTag({property: 'og:site_name', content: 'Carvry | Car Research Simplified'}, 'property=\'og:site_name\'');
  meta.updateTag({property: 'og:locale', content: 'en_US'}, 'property=\'og:locale\'');

  meta.updateTag({name: 'twitter:card', content: description}, 'name=\'twitter:card\'');
  meta.updateTag({name: 'twitter:site', content: '@CarvryApp'}, 'name=\'twitter:site\'');
  meta.updateTag({name: 'twitter:creator', content: '@CarvryApp'}, 'name=\'twitter:creator\'');
  meta.updateTag({name: 'description', content: description}, 'name=\'description\'');

  if (imageUrl) {
    meta.updateTag({property: 'og:image', content: imageUrl}, 'property=\'og:image\'');
    meta.updateTag({property: 'og:image:secure_url', content: imageUrl}, 'property=\'og:image:secure_url\'');
  }

  if (type) {
    meta.updateTag({property: 'og:type', content: type}, 'property=\'og:type\'');
  }
};
